import { useQuery } from "@tanstack/react-query"

import MetricDisplay from "./MetricDisplay.tsx"
import MetricsCard from "./MetricsCard.tsx"

import type { MonthlyDisplayData } from "../types/monthlyDisplayTypes.ts"

export default function MonthlyDisplay({
  fetcher,
  location,
}: {
  fetcher: () => Promise<MonthlyDisplayData>
  location: number
}) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["monthlyDisplay", { location }],
    queryFn: fetcher,
    refetchInterval: 10000,
  })

  return (
    <MetricsCard title="Monthly Totals">
      <MetricDisplay
        label="Total Gas to Pipeline"
        value={data ? data.gasToPipeline : 0}
        loading={isPending}
        error={isError}
        unit="MMBtu"
      />
      <MetricDisplay
        label="Average Daily Gas to Pipeline"
        value={data ? data.averageGasToPipeline : 0}
        loading={isPending}
        error={isError}
        unit="MMBtu"
      />
      <MetricDisplay
        label="Average Daily Uptime"
        loading={isPending}
        error={isError}
        value={data ? data.averageUptime : 0}
        unit="%"
      />
      {/* Spacer: renders an invisible MetricDisplay as a direct flex sibling
          (via className passthrough) so its box matches a real row exactly —
          same DOM, same font metrics, same gap-2 spacing. Keeps plant summary
          cards aligned with the taller SPL For Hire card (which has an extra
          Monthly metric). MonthlyDisplay is always the last card. */}
      <MetricDisplay className="invisible" label="spacer" value={0} />
      <MetricDisplay className="invisible" label="spacer" value={0} />
    </MetricsCard>
  )
}
